const fieldCaseStyle: any = {
  curp: "uppercase",
  email: "lowercase",
  rfc: "uppercase",
  rfc_company: "uppercase",
  name: "capitalize",
  first_name: "capitalize",
  second_name: "capitalize",
  first_last_name: "capitalize",
  second_last_name: "capitalize",
};

export const getFieldCaseStyle = (field: string): string => {
  return fieldCaseStyle[field] || "";
};
